import ReactDatePicker from 'react-date-picker/dist/entry.nostyle';
import './style.scss';

export default {
  component: ReactDatePicker,
  specialProps: (props = {}) => {
    const required = !!props.required && (props.value === undefined || props.value === null || props.value === '');

    return ({
      className: `${required ? 'c-ReactDatePickerRequired' : 'c-ReactDatePicker'} ${props.className || ''}`,
      required: false,
    });
  },
};
